module.exports = __webpack_public_path__ + "static/media/wink-emoji-svgrepo-com.b4293417.svg";